import { ApiGetRequest } from '../../api';

export const state = {
  data: {
    total_ijin: 0,
    loading_ijin: false,
    total_tunjangan: 0,
    loading_tunjangan: false,
    total_lembur: 0,
    loading_lembur: false,
    total_potongan: 0,
    loading_potongan: false,
    loading_chart: false,
    top_distributor: [],
    loading_top: false,
    chartData: {
      series: [
        {
          name: 'Sales',
          data: [],
        },
        {
          name: 'Purchase',
          data: [],
        },
      ],
      chartoptions: {
        chart: {
          height: 350,
          type: 'area',
          toolbar: {
            show: false,
          },
        },
        colors: ['#556ee6', '#f1b44c', '#f44336', '#03a9f4'],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [20, 100, 100, 100],
          },
        },
        xaxis: {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
        },
        markers: {
          size: 3,
          strokeWidth: 3,

          hover: {
            size: 4,
            sizeOffset: 2,
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
        },
      },
    },
    chartDataLembur: {
      series: [
        {
          name: 'Sales',
          data: [],
        },
        {
          name: 'Purchase',
          data: [],
        },
      ],
      chartoptions: {
        chart: {
          height: 350,
          type: 'area',
          toolbar: {
            show: false,
          },
        },
        colors: ['#556ee6', '#f1b44c', '#f44336', '#03a9f4'],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [20, 100, 100, 100],
          },
        },
        xaxis: {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
        },
        markers: {
          size: 3,
          strokeWidth: 3,

          hover: {
            size: 4,
            sizeOffset: 2,
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
        },
      },
    },
  },
};

export const mutations = {
  changeDashboard(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getTotalIjin({ commit }) {
    commit('changeDashboard', {
      loading_ijin: true,
    });

    let result = await ApiGetRequest(`dashboard/ijin`);
    commit('changeDashboard', {
      total_ijin: result.data.error ? 0 : result.data.object,
      loading_ijin: false,
    });

    return !result.error ? true : false;
  },

  async getTotalLembur({ commit }) {
    commit('changeDashboard', {
      loading_lembur: true,
    });

    let result = await ApiGetRequest(`dashboard/lembur`);
    commit('changeDashboard', {
      total_lembur: result.data.error ? 0 : result.data.object,
      loading_lembur: false,
    });

    return !result.error ? true : false;
  },

  async getTotalTunjangan({ commit }) {
    commit('changeDashboard', {
      loading_tunjangan: true,
    });

    let result = await ApiGetRequest(`dashboard/tunjangan`);
    commit('changeDashboard', {
      total_tunjangan: result.data.error ? 0 : result.data.object,
      loading_tunjangan: false,
    });

    return !result.error ? true : false;
  },

  async getTotalPotongan({ commit }) {
    commit('changeDashboard', {
      loading_potongan: true,
    });

    let result = await ApiGetRequest(`dashboard/potongan`);
    commit('changeDashboard', {
      total_potongan: result.data.error ? 0 : result.data.object,
      loading_potongan: false,
    });

    return !result.error ? true : false;
  },

  async getChartGajiKaryawan({ commit, state }) {
    commit('changeDashboard', {
      loading_chart: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`dashboard/chart-gaji`);
    commit('changeDashboard', {
      chartData: {
        ...data.chartData,
        series: [
          {
            name: 'Slip Gaji',
            data: !result.error ? result.data.object.gaji : [],
          },
        ],
      },
      loading_chart: false,
    });

    return !result.error ? true : false;
  },

  async getChartLemburKaryawan({ commit, state }) {
    commit('changeDashboard', {
      loading_chart: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`dashboard/chart-lembur`);
    commit('changeDashboard', {
      chartDataLembur: {
        ...data.chartDataLembur,
        series: [
          {
            name: 'Lembur',
            data: !result.error ? result.data.object.lembur : [],
          },
        ],
      },
      loading_chart: false,
    });

    return !result.error ? true : false;
  },

  async getTopDistributor({ commit }) {
    commit('changeDashboard', {
      loading_top: true,
    });

    let result = await ApiGetRequest(`dashboard/top-distributor`);
    commit('changeDashboard', {
      top_distributor: !result.error ? result.data.object : [],
      loading_top: false,
    });

    return !result.error ? true : false;
  },
};
